import { render } from "./SessionLocked.vue?vue&type=template&id=624c56f6&scoped=true"
import script from "./SessionLocked.vue?vue&type=script&lang=js"
export * from "./SessionLocked.vue?vue&type=script&lang=js"

import "./SessionLocked.vue?vue&type=style&index=0&id=624c56f6&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624c56f6"]])

export default __exports__